import { forwardRef, type Ref, type SVGProps } from "react";
const IconCreditCardOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M19.5 19a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.204 14.01A2 2 0 0 1 24 16v9l-.01.204a2 2 0 0 1-1.786 1.785L22 27H6l-.204-.01a2 2 0 0 1-1.785-1.786L4 25v-9a2 2 0 0 1 1.796-1.99L6 14h16zM6 25h16v-9H6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.204 5.01A2 2 0 0 1 28 7v9l-.01.204a2 2 0 0 1-1.786 1.785L26 18h-1v-2h1v-5H10v2H8V7a2 2 0 0 1 1.796-1.99L10 5h16zM10 9h16V7H10z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCreditCardOutlineSVG);
ForwardRef.displayName = "IconCreditCardOutline";
export { ForwardRef as IconCreditCardOutline };
